import React, { useContext } from "react";
import Contact from "../pages/public-page/Contact";
import { Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

/// Css
import "./../index.css";
import "./../chart.css";
import "./../step.css";

/// Layout
import PublicNav from "../layouts/nav/Public";
import Footer from "../layouts/Footer";

import { ThemeContext } from "../../context/ThemeContext";
//Scroll To Top
import ScrollToTop from "../layouts/ScrollToTop";

/// Dashboard
import EmptyPage from "../pages/dashboard/EmptyPage";

/// Pages
import LockScreen from "../pages/error/LockScreen";
import Error400 from "../pages/error/Error400";
import Error403 from "../pages/error/Error403";
import Error404 from "../pages/error/Error404";
import Error500 from "../pages/error/Error500";
import Error503 from "../pages/error/Error503";

import PlayerRegistration from "../pages/public-page/PlayerRegistration";
import PlayerEnquiry from "../pages/public-page/PlayerEnquiry";
import PrivacyPolicy from "../pages/public-page/PrivacyPolicy";
import EmailVerification from "../pages/public-page/EmailVerification";
import TenantRegistration from "../pages/public-page/tenant-registration";
import PublicPlayerPayment from "../pages/public-page/PublicPlayerPayment";

const PublicDashboard = () => {
  const allroutes = [
    { url: "player-registration/:id", component: <PlayerRegistration /> },
    { url: "player-enquiry/:id", component: <PlayerEnquiry /> },
    { url: "player/payment/:id", component: <PublicPlayerPayment /> },
    { url: "privacy-policy", component: <PrivacyPolicy /> },
    { url: "contact", component: <Contact /> },
    { url: "academy-registration", component: <TenantRegistration /> },

    /// pages
    { url: "empty", component: <EmptyPage /> },
  ];

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  return (
    <>
      <div
        id="main-wrapper"
        className={`show  ${sidebariconHover ? "iconhover-toggle" : ""} ${
          sideMenu ? "menu-toggle" : ""
        }`}
      >
        <PublicNav />
        <div className="">
          <div
            className="container-fluid"
            style={{ minHeight: window.screen.height - 45 }}
          >
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default PublicDashboard;
